export type FrameGroup = {
  group: string;
  opex: keyof FinancialFrameUpdate;
  capex: keyof FinancialFrameUpdate;
};

export const FRAME_GROUPS: FrameGroup[] = [
  {
    group: 'growthNewCmps',
    opex: 'growthNewCmpsOpex',
    capex: 'growthNewCmpsCapex',
  },
  {
    group: 'fulfilmentAndReplenishment',
    opex: 'fulfilmentAndReplenishmentOpex',
    capex: 'fulfilmentAndReplenishmentCapex',
  },
  {
    group: 'spaceOptimisationWith3rdParty',
    opex: 'spaceOptimisationWith3rdPartyOpex',
    capex: 'spaceOptimisationWith3rdPartyCapex',
  },
  {
    group: 'commercialAndCoworkerAreasAndConcept',
    opex: 'commercialAndCoworkerAreasAndConceptOpex',
    capex: 'commercialAndCoworkerAreasAndConceptCapex',
  },
  {
    group: 'realEstate',
    opex: 'realEstateOpex',
    capex: 'realEstateCapex',
  },
  {
    group: 'digitalTechnology',
    opex: 'digitalTechnologyOpex',
    capex: 'digitalTechnologyCapex',
  },
];

export type FinancialFrame = {
  id: number;
  countryId: string;
  countryName: string;
  fiscalYear: string;
  growthNewCmpsOpex: number;
  growthNewCmpsCapex: number;
  countryPAndLOpex: number;
  countryPAndLCapex: number;
  fulfilmentAndReplenishmentOpex: number;
  fulfilmentAndReplenishmentCapex: number;
  centresPortfolioOpex: number;
  centresPortfolioCapex: number;
  propertyExitsOpex: number;
  propertyExitsCapex: number;
  commercialAndCoworkerAreasAndConceptOpex: number;
  commercialAndCoworkerAreasAndConceptCapex: number;
  realEstateOpex: number;
  realEstateCapex: number;
  spaceOptimisationWith3rdPartyOpex: number;
  spaceOptimisationWith3rdPartyCapex: number;
  digitalTechnologyOpex: number;
  digitalTechnologyCapex: number;
  updatedAt: string;
  updatedBy: string;
};

export type FinancialFrameUpdate = {
  growthNewCmpsOpex: number;
  growthNewCmpsCapex: number;
  countryPAndLOpex: number;
  countryPAndLCapex: number;
  fulfilmentAndReplenishmentOpex: number;
  fulfilmentAndReplenishmentCapex: number;
  centresPortfolioOpex: number;
  centresPortfolioCapex: number;
  propertyExitsOpex: number;
  propertyExitsCapex: number;
  commercialAndCoworkerAreasAndConceptOpex: number;
  commercialAndCoworkerAreasAndConceptCapex: number;
  realEstateOpex: number;
  realEstateCapex: number;
  spaceOptimisationWith3rdPartyOpex: number;
  spaceOptimisationWith3rdPartyCapex: number;
  digitalTechnologyOpex: number;
  digitalTechnologyCapex: number;
};

export type FinancialFramesState = {
  loading: boolean;
  loaded: boolean;
  updateLoading: boolean;
  error: Error;
  financialFrames: FinancialFrame[];
};

export const initialState: FinancialFramesState = {
  loading: false,
  loaded: false,
  updateLoading: false,
  error: null,
  financialFrames: [],
};
